import { fetchBadgeConfigs } from '@/apis';
import { cachePromise } from '@/utils';

export const BADGE_ID_MAPPER = {
  TASKS: 'tasks',
  CUSTOM_AVATAR: 'custom-avatar',
  WORKFLOW_AUTOMATION: 'workflow-automation',
  DRIVE: 'drive',
  CUSTOM_AIC: 'custom-aic'
};

export const fetchBadgeConfigs$Catch = cachePromise(async () => {
  return await fetchBadgeConfigs();
});

const BADGE_LIST_SESSION_KEY = 'fbc_auto-expire-badge_list';
/**
 * SessionStorage -> Memory -> API
 * @returns badge list
 */
export const getAllBadgeConfigs$Cache = async () => {
  let list = null;
  try {
    const storedValue = sessionStorage.getItem(BADGE_LIST_SESSION_KEY);
    if (storedValue && !['undefined', 'null'].includes(storedValue)) {
      list = JSON.parse(storedValue);
    }
  } catch (error) {
    console.error(`Error to get ${BADGE_LIST_SESSION_KEY}: `, error);
  }
  if (!list || !Array.isArray(list)) {
    list = await fetchBadgeConfigs$Catch();
  }
  try {
    if (Array.isArray(list)) {
      sessionStorage.setItem(BADGE_LIST_SESSION_KEY, JSON.stringify(list));
    }
  } catch (error) {
    console.error(`Error to set ${BADGE_LIST_SESSION_KEY}: `, error);
    sessionStorage.removeItem(BADGE_LIST_SESSION_KEY);
  }
  return list;
}
